import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React from "react";
import { useSelector } from "react-redux";
import UOAModal from "../../../../components/Modals/UOAModal/UOAModal";
import { findCap, paginate } from "../../utils";
import UOAFilter from "../UOAFilters";
import UOARightPanel from "../UOARightPanel";
import TableContentHeading from "./tableContentHeading";
import TableFooterPagination from "./tableFooterPaginaion";
import TableHeadingRow from "./tableHeadingRow";
import TableRowCells from "./tableRowCells";

const UOAWebView = ({
  styles,
  getFilters,
  setFilters,
  zoom,
  errorUoa,
  isdata,
  StocksColSpam,
  optionColSpam,
  setStateAction,
  loadUOAData,
  accessLevel,
  orderBy,
  order,
  sortData,
  uoaEndRef,
  isMobile,
  articles,
}) => {
  const state = useSelector((state) => state.UOAState);

  return (
    <Grid container spacing={0} style={{ zoom: zoom }}>
      <Grid item xs={12} md={9} style={{ height: "100%" }}>
        <div style={styles.leftContainer}>
          <Grid container style={{ paddingBottom: "20px" }}>
            <UOAFilter
              styles={styles}
              getFilters={(data) => getFilters(data)}
              setFilters={(data) => setFilters(data)}
            />
          </Grid>
          <div style={{ ...styles.tableContainer }}>
            {errorUoa !== "" && <Alert severity="error">{errorUoa}</Alert>}
            <Table style={{ borderCollapse: "unset" }} size="small">
              <TableHead>
                <TableHeadingRow
                  styles={styles}
                  showLoader={state.showLoader}
                  isdata={isdata}
                  StocksColSpam={StocksColSpam}
                  optionColSpam={optionColSpam}
                  setStateAction={(data) => setStateAction(data)}
                  state={state}
                  loadUOAData={loadUOAData}
                  findCap={(data) => findCap(data)}
                  accessLevel={accessLevel}
                />
                <TableContentHeading
                  setStateAction={(data) => setStateAction(data)}
                  state={state}
                  styles={styles}
                  orderBy={orderBy}
                  order={order}
                  sortData={(data) => sortData(data)}
                  uoaEndRef={uoaEndRef}
                />
              </TableHead>
              <TableBody>
                {!!state.localUOA
                  ? paginate(
                      [].slice.call(state.localUOA).sort((a, b) => {
                        if (
                          !orderBy ||
                          (!(
                            typeof a[orderBy] === "number" ||
                            typeof a[orderBy] === "string"
                          ) &&
                            // eslint-disable-next-line no-self-compare
                            typeof a[orderBy] === typeof a[orderBy])
                        )
                          return 0;

                        if (typeof a[orderBy] === "number")
                          return order === "desc"
                            ? a[orderBy] - b[orderBy]
                            : b[orderBy] - a[orderBy];
                        else {
                          return order === "desc"
                            ? a[orderBy].localeCompare(b[orderBy])
                            : b[orderBy].localeCompare(a[orderBy]);
                        }
                      }),
                      state.rowsPerPage,
                      state.page
                    ).map((row, index) => {
                      return (
                        <TableRowCells
                          setStateAction={(data) => setStateAction(data)}
                          myKey={index}
                          window={window}
                          row={row}
                          styles={styles}
                        />
                      );
                    })
                  : ""}
                {state.refreshUOA || (
                  <TableRow>
                    <TableCell
                      colspan="14"
                      style={{
                        textAlign: "center",
                        background: "#f6f6f6",
                      }}
                    >
                      First reading at 10:00am.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooterPagination
                styles={styles}
                state={state}
                setStateAction={(data) => setStateAction(data)}
                rowsPerPage={state.rowsPerPage}
                page={state.page}
              />
            </Table>
          </div>

          {state.isVolClicked ? (
            <UOAModal
              accessLevel={accessLevel}
              isMobile={isMobile}
              isVolClicked={state.isVolClicked}
              handleModalClose={() => setStateAction({ isVolClicked: false })}
              modalRowData={state.modalRowData}
              date={state.date}
            ></UOAModal>
          ) : (
            ""
          )}
        </div>
      </Grid>
      {!isMobile && (
        <Grid item xs={12} md={3} style={{ height: "100%" }}>
          <UOARightPanel styles={styles} articles={articles} />
        </Grid>
      )}
    </Grid>
  );
};
export default UOAWebView;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/UOAWebView.jsx